// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Comment from "./comment.js"
import Contact from "./contact.js"
import Subject from "./subject.js"

const modelClassData = {
  "attributes": {
    "contact_id": {
      "column": {
        "default": null,
        "name": "contact_id",
        "null": true,
        "type": "uuid"
      },
      "name": "contact_id",
      "selected_by_default": null,
      "translated": null
    },
    "subject_id": {
      "column": {
        "default": null,
        "name": "subject_id",
        "null": false,
        "type": "uuid"
      },
      "name": "subject_id",
      "selected_by_default": null,
      "translated": null
    },
    "conversation_type": {
      "column": {
        "default": null,
        "name": "conversation_type",
        "null": false,
        "type": "string"
      },
      "name": "conversation_type",
      "selected_by_default": null,
      "translated": null
    },
    "duration": {
      "column": {
        "default": null,
        "name": "duration",
        "null": true,
        "type": "integer"
      },
      "name": "duration",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": true,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "occurred_at": {
      "column": {
        "default": null,
        "name": "occurred_at",
        "null": true,
        "type": "datetime"
      },
      "name": "occurred_at",
      "selected_by_default": null,
      "translated": null
    },
    "responsible_id": {
      "column": {
        "default": null,
        "name": "responsible_id",
        "null": true,
        "type": "uuid"
      },
      "name": "responsible_id",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "created",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "translated_conversation_type": {
      "column": null,
      "name": "translated_conversation_type",
      "selected_by_default": false,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "Conversation",
  "collectionKey": "conversations",
  "collectionName": "conversations",
  "i18nKey": "conversation",
  "camelizedLower": "conversation",
  "name": "Conversation",
  "nameDasherized": "conversation",
  "pluralName": "conversations",
  "ransackable_associations": [
    {
      "className": "Comment",
      "collectionName": "comments",
      "foreignKey": "commentable_id",
      "name": "comments",
      "macro": "has_many",
      "resource_name": "Comment",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "responsible_id",
      "name": "responsible",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Subject",
      "collectionName": "subjects",
      "foreignKey": "subject_id",
      "name": "subject",
      "macro": "belongs_to",
      "resource_name": "Subject",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "contact_id",
      "column": {
        "default": null,
        "name": "contact_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "conversation_type",
      "column": {
        "default": null,
        "name": "conversation_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "duration",
      "column": {
        "default": null,
        "name": "duration",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "occurred_at",
      "column": {
        "default": null,
        "name": "occurred_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "old_contact_id",
      "column": {
        "default": null,
        "name": "old_contact_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_responsible_id",
      "column": {
        "default": null,
        "name": "old_responsible_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_subject_id",
      "column": {
        "default": null,
        "name": "old_subject_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "responsible_id",
      "column": {
        "default": null,
        "name": "responsible_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "created",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "subject_id",
      "column": {
        "default": null,
        "name": "subject_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Comment",
      "collectionName": "comments",
      "foreignKey": "commentable_id",
      "name": "comments",
      "macro": "has_many",
      "resource_name": "Comment",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Subject",
      "collectionName": "subjects",
      "foreignKey": "subject_id",
      "name": "subject",
      "macro": "belongs_to",
      "resource_name": "Subject",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "responsible_id",
      "name": "responsible",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    }
  ],
  "paramKey": "conversation",
  "primaryKey": "id"
}

/** Frontend model for Conversation. */
export default class Conversation extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  contactId() {
    return this.readAttributeUnderscore("contact_id")
  }

  /** @returns {boolean} */
  hasContactId() {
    const value = this.contactId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  subjectId() {
    return this.readAttributeUnderscore("subject_id")
  }

  /** @returns {boolean} */
  hasSubjectId() {
    const value = this.subjectId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  conversationType() {
    return this.readAttributeUnderscore("conversation_type")
  }

  /** @returns {boolean} */
  hasConversationType() {
    const value = this.conversationType()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  duration() {
    return this.readAttributeUnderscore("duration")
  }

  /** @returns {boolean} */
  hasDuration() {
    const value = this.duration()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  occurredAt() {
    return this.readAttributeUnderscore("occurred_at")
  }

  /** @returns {boolean} */
  hasOccurredAt() {
    const value = this.occurredAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  responsibleId() {
    return this.readAttributeUnderscore("responsible_id")
  }

  /** @returns {boolean} */
  hasResponsibleId() {
    const value = this.responsibleId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedConversationType() {
    return this.readAttributeUnderscore("translated_conversation_type")
  }

  /** @returns {boolean} */
  hasTranslatedConversationType() {
    const value = this.translatedConversationType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./comment.js").default>} */
  comments() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["commentable_id_eq"] = this.id()
    ransack["commentable_type_eq"] = "Conversation"

    return new Collection(
      {
        reflectionName: "comments",
        model: this,
        modelClass: Comment
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./comment.js").default>>} */
  loadComments() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["commentable_id_eq"] = this.id()
    ransack["commentable_type_eq"] = "Conversation"

    return this._loadHasManyReflection(
      {
        reflectionName: "comments",
        model: this,
        modelClass: Comment
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./comment.js").default>>} */
  ensureCommentsLoaded() {
    return this.ensureAssociationLoaded("comments")
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("contactId" in this)) throw new Error("Foreign key method wasn't defined: contactId")

    const id = this.contactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }

  /** @returns {import("./subject.js").default | null} */
  subject() {
    return this._readBelongsToReflection({modelClass: Subject, reflectionName: "subject"})
  }

  /** @returns {Promise<import("./subject.js").default | null>} */
  loadSubject() {
    if (!("subjectId" in this)) throw new Error("Foreign key method wasn't defined: subjectId")

    const id = this.subjectId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "subject",
        model: this,
        modelClass: Subject
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./subject.js").default | null>} */
  ensureSubjectLoaded() {
    return this.ensureAssociationLoaded("subject")
  }

  /** @returns {import("./contact.js").default | null} */
  responsible() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "responsible"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadResponsible() {
    if (!("responsibleId" in this)) throw new Error("Foreign key method wasn't defined: responsibleId")

    const id = this.responsibleId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "responsible",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureResponsibleLoaded() {
    return this.ensureAssociationLoaded("responsible")
  }
}
